import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import GenericPanel from './GenericPanel';
import { EDeliveryConsentContent } from './ConsentContent';
import { PsBeaconControl, PsBeaconControlGroup, PsBeaconError } from '../shared/BeaconRegister';

const EDeliveryPanel = ({
    panelNum,
    headerText = 'Consent to Electronic Access and Delivery',
    open,
    checkError,
    handleChange,
}) => (
    <GenericPanel
        headerText={
            <>
                <span>
                    {panelNum}. {headerText}
                </span>
                {checkError?.checkedEdelivery && (
                    <Box>
                        <PsBeaconError id="e-delivery-field-error">
                            Please fill in all required fields to continue.
                        </PsBeaconError>
                    </Box>
                )}
            </>
        }
        id="edelivery-container"
        open={open}>
        <Typography
            id={EDeliveryConsentContent.headerId}
            type="body" scale={100} bold
            sx={{ paddingBottom: '40px' }}>
            {EDeliveryConsentContent.header}
        </Typography>
        {EDeliveryConsentContent.consent.map((t) => (
            <div key={t.key} id={t.id}>
                <Box>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t.consentText,
                        }}
                    />
                </Box>
                <br />
            </div>
        ))}
        <Box id="e-delivery-checkbox-container">
            <PsBeaconControlGroup>
                <PsBeaconControl
                    id="checkedEdelivery-control"
                    inline
                    style={{ paddingBottom: '24px', paddingTop: '40px' }}>
                    <input
                        required
                        type="checkbox"
                        name="checkedEdelivery"
                        id="checkedEdelivery"
                        onChange={handleChange && handleChange('checkedEdelivery')}
                    />
                    <label slot="label" id="checkedEdelivery-label" htmlFor="checkedEdelivery">
                        {EDeliveryConsentContent.checkboxLabel}
                    </label>
                    <div slot="error">This field is required.</div>
                </PsBeaconControl>
            </PsBeaconControlGroup>
        </Box>
    </GenericPanel>
);

export default EDeliveryPanel;
